import React from "react";
import { Col } from "react-bootstrap";
import Button from "../Buttons/Button";
import { buttonNameConstants, buttonTypeConstants } from "../../../constants";

const ModalActionButtons = ({
  handleCloseModal,
  cancelButtonLabel = buttonNameConstants.CANCEL,
  submitButtonLabel = buttonNameConstants.ADD,
  className = "",
  isLoading = false,
}) => {
  return (
    <Col md={12} className={`m-0 d-flex gap-2 ${className}`}>
      <Button
        type="button"
        label={cancelButtonLabel}
        handleClick={handleCloseModal}
        buttonType={buttonTypeConstants.GHOST_BUTTON}
        className="w-100"
        isDisabled={isLoading}
      />
      <Button
        type="submit"
        label={submitButtonLabel}
        buttonType={buttonTypeConstants.PRIMARY_BUTTON}
        className="w-100"
        isLoading={isLoading}
        isDisabled={isLoading}
      />
    </Col>
  );
};

export default ModalActionButtons;
